module.exports = __webpack_public_path__ + "img/test-scene.21a406ea.png";